 $(document).ready(function() {


   //hover show image of blog------------------
    $('.hover-container').on('mousemove', function(event) {
      var $img = $(this).find('img');
      var rect = this.getBoundingClientRect();
      
      // Calculate position relative to the container
      var xPos = rect.left - event.clientX;
      var yPos = event.clientY - rect.top - 100;
  
      // Calculate opacity based on mouse position (0 to 1)
      var opacity = Math.min(1, Math.max(0, 1 - (yPos / rect.height)));
  
      
      if(xPos < (-60)){
         var xPosEnd = event.clientX - event.clientX + 10;
      }else{
         var xPosEnd = xPos;
      }
      
      // Show and move the image
      $img.css({
        'display': 'block',
        'transform-style': 'preserve-3d',
        'will-change': 'transform',
        'transform': 'translate3d(' + yPos + 'px, ' + xPosEnd + 'px, 0)',
        'opacity': 1
      });
    }).on('mouseleave', function() {
      // Hide the image when the mouse leaves
      $(this).find('img').css('display', 'none');
    });
    //END hover show image of blog------------------
   


   //hover hamburger menu header------------
    $('.hamburger-menu').mousemove(function(event) {
      var rect = this.getBoundingClientRect();
      var xPos = event.clientX - rect.left;
      var yPos = event.clientY - rect.top;

      var currentValue = 0; // Initial value
      var step = 0.03; // Increment step
  
      var xP = 40 - xPos;
      var yP = 40 - yPos;

      $(this).find('.social-circle').each(function(index) {
        var transformValue = `translate3d(${yP * 0.1220}px, ${xP * 0.1220}px, 0px) 
                              scale3d(1, 1, 1) 
                              rotateX(0deg) 
                              rotateY(0deg) 
                              rotateZ(0deg) 
                              skew(0deg, 0deg)`;

        $(this).css({
          'transform': transformValue,
          'transform-style': 'preserve-3d',
          'will-change': 'transform'
        });
      });
      
      var $imgWhite = $(this).find('img.hoverimg');
      var $imgBlack = $(this).find('img.show');
      $imgWhite.css({
        'transform-style': 'preserve-3d',
        'will-change': 'transform',
        'opacity': 1
      });

      $imgBlack.css({
        'transform-style': 'preserve-3d',
        'will-change': 'transform',
        'opacity': 0
      });
      
    });

    $('.hamburger-menu').mouseleave(function() {
      $(this).find('.social-circle').css({
        'transform': 'translate3d(0.0007px, 0.0006px, 0px) scale3d(0, 0, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
      });
      $(this).find('img.hoverimg').css({
        'opacity': 0
      });
      $(this).find('img.show').css({
        'opacity': 1
      });
    });
   //END hover hamburger menu header

   
   // START hover social-circle ---------------------------
    $('.social-icon').mousemove(function(event) {
      var itemWidth = $(this).width();
      var rect = this.getBoundingClientRect();
      var xPos = event.clientX - rect.left;
      var yPos = event.clientY - rect.top;

      var currentValue = 0; // Initial value
      var step = 0.03; // Increment step

      console.log('itemWidth = '+itemWidth);
      var xP = itemWidth - xPos;
      var yP = itemWidth - yPos;

      $(this).find('.social-circle').each(function(index) {
        var transformValue = `translate3d(${yP * 0.0120}px, ${xP * 0.01220}px, 0px) 
                              scale3d(1, 1, 1) 
                              rotateX(0deg) 
                              rotateY(0deg) 
                              rotateZ(0deg) 
                              skew(0deg, 0deg)`;

        $(this).css({
          'transform': transformValue,
          'transform-style': 'preserve-3d',
          'will-change': 'transform'
        });
      });
      
    });
    $('.social-icon').mouseleave(function() {
      $(this).find('.social-circle').css({
        'transform': 'translate3d(0.0007px, 0.0006px, 0px) scale3d(0, 0, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
      });
    });

   //END hover social-circle --------------------------------


   //jquery hover ready connect section above footer
   $(".ready-section").on("mousemove", function(event) {

      const section = $('.ready-section');
      const sectionWidth = section.width();
      const sectionHeight = section.height();
  
      // Calculate the percentage position of the mouse within the section
      const xPercent = (event.pageX - section.offset().left) / sectionWidth;
      const yPercent = (event.pageY - section.offset().top) / sectionHeight;
  
      // Translate these percentages to the desired transform range
      const xTranslate = (xPercent * 100) - 50; // From -50 to 50
      const yTranslate = (yPercent * 14) - 7;  // From -7 to 7
     
      const cursor = $(this).find(".project-circle");

      cursor.css({
        "opacity": 1,
        'transform-style': 'preserve-3d',
        'will-change': 'transform',
        "transform": `translate3d(${xTranslate}vw, ${yTranslate}vh, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
      });
    }).on("mouseleave", function() {

      const section = $('.ready-section');
      const sectionWidth = section.width();
      const sectionHeight = section.height();
  
      const xPercent = (event.pageX - section.offset().left) / sectionWidth;
      const yPercent = (event.pageY - section.offset().top) / sectionHeight;
  
      const xTranslate = (xPercent * 100) - 50; // From -50 to 50
      const yTranslate = (yPercent * 14) - 7;  // From -7 to 7
     
      const cursor = $(this).find(".project-circle");
     
      $(this).find(".project-circle").css({
        "opacity": 0,
        'transform-style': 'preserve-3d',
        'will-change': 'transform',
        "transform": `translate3d(${xTranslate}vw, ${yTranslate}vh, 0) scale3d(0, 0, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
      });
     
    });//END jquery hover ready connect section above footer==============================


     //jquery hover project-card
   $(".project-card").on("mousemove", function(event) {
        const item = $(this);
        const itemWidth = item.width();
        const itemHeight = item.height();
    
        const xPercent = (event.pageX - item.offset().left) / itemWidth;
        const yPercent = (event.pageY - item.offset().top) / itemHeight;
    
        const xTranslate = (xPercent * 350) - 175;
        const yTranslate = (yPercent * 380) - 190;  
       
        const cursor = $(this).find(".project-circle");
  
        cursor.css({
          "opacity": 1,
          'transform-style': 'preserve-3d',
          'will-change': 'transform',
          "transform": `translate3d(${xTranslate}%, ${yTranslate}%, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
        });

       const xTranslateImg = (xPercent * 40) + 20; // From 15 to -15
       const yTranslateImg = (yPercent * 32) + 16;  // From 15 to -15
     
      $(this).find("img.mainImg_project").css({
        'transform-style': 'preserve-3d',
        'will-change': 'transform',
        "transform": `translate3d(${xTranslateImg}px, ${yTranslateImg}px, 0) scale3d(1.3, 1.3, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
      });
     
   }).on('mouseleave', function() {
      const cursor = $(this).find(".project-circle");
  
        cursor.css({
          "opacity": 0,
          'transform-style': 'preserve-3d',
          'will-change': 'transform',
          "transform": 'translate3d(0.021%, 0.02688%, 0px) scale3d(0, 0, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });

     $(this).find("img.mainImg_project").css({
        'transform-style': 'preserve-3d',
        'will-change': 'transform',
        'transform': 'translate3d(-0.0032px, -0.0028px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
    });
     
   });
     //END jquery hover project-card=======================

      //jquery hover drawmenu
   $("#menu-drawer").on("mousemove", function(event) {

    var $menuDrawer = $('.menu-drawer__navigation-container');
     if (!$menuDrawer.is(event.target) && $menuDrawer.has(event.target).length === 0)
      {
        const section = $('#menu-drawer');
        const sectionWidth = section.width();
        const sectionHeight = section.height();
    
        const xPercent = (event.pageX - section.offset().left) / sectionWidth;
        const yPercent = (event.pageY - section.offset().top) / sectionHeight;
    
        const xTranslate = (xPercent * 100) - 50; // From -50 to 50
        const yTranslate = (yPercent * 100) - 50;  // From -50 to 50
       
        const cursor = $(this).find(".remove-circle");
  
        cursor.css({
          "opacity": 1,
          'transform-style': 'preserve-3d',
          'will-change': 'transform',
          "transform": `translate3d(${xTranslate}vw, ${yTranslate}vh, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
        });
      }else{

        const cursor = $(this).find(".remove-circle");
        cursor.css({
          "opacity": 0,
          'transform-style': 'preserve-3d',
          'will-change': 'transform',
          "transform": 'translate3d(0.006vw, 0.006vh, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
        
      }
     
  });  //END jquery hover drawmenu=======================

   
   
   $('.slider-testimonials').slick({
    centerMode: true,
    centerPadding: '25%',
    slidesToShow: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 9000,
     infinite: false,
    dots: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          centerPadding: '15%',
        }
      }
    ]
  });

   //click close menu nav
   $(".remove-circe-mobile").click(function(){
     $('.header__icon.header__icon--menu.header__icon--summary').trigger("click");
    
   });
   $(".remove-circle").click(function(){
     $('.header__icon.header__icon--menu.header__icon--summary').trigger("click");
    
   });


   
});


 //function animation display element
function checkVisibility() {

   //display fun line======
    $('.fun-line').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 200;

      if (elementTop < windowBottom) {
        $(this).css({
          'width': '100%',
        });
      }
    });

    //display project-card ======
    $('.project-card').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 50;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
      }
    });
  
  //display post item on blog/news
    $('.scroll-triggered-element').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 50;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
      }
    });

   //display heading on blog/news
   $('.scroll-triggered-element-heading').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 50;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
      }
    });


    //display sub-heading on blog/news
  $('.scroll-triggered-element-subheading').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 60;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
      }
    });


    //display text from left to right
   $('.left-to-right-fade-in').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 60;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
      }
    });

   //display text from bottom to top
   $('.bottom-to-top-fade-in').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 50;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
      }
    });

  
  //display photo-animation
   $('.photo-animation').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 150;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
        $(this).find(".absolute-background").css({
          "width": 0,
        });
      }
    });


   //display project detail image with text
   $('.image-text-project').each(function() {
      var elementTop = $(this).offset().top;
      var windowBottom = $(window).scrollTop() + $(window).height() - 120;

      if (elementTop < windowBottom) {
        $(this).css({
          'opacity': '1',
          'transform-style': 'preserve-3d',
          'transform': 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
        });
        $(this).find(".absolute-background").css({
          "width": 0,
        });
      }
    });

  
  
  }

  $(window).on('load scroll', function() {
    checkVisibility();
  });

  // Trigger check on initial load
  $(document).ready(function() {
    checkVisibility();
  });


function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

jQuery( document ).ready( function() {
	window.addEventListener('scroll', function(e) {
		if( isOnScreen( jQuery( '.track' ) ) ) { /* Pass element id/class you want to check */
			//console.log( 'The specified container is in view.' );
 		}else{
          //console.log( 'NOOOOOO' );
        }
	});
});

var windowWidth = $(window).width();

var position = $(window).scrollTop(); 
$(window).scroll(function(e) {
    var scroll = $(window).scrollTop();
    if(scroll > position) {

      //check scroll screen turns black when hovering over blog posts
       if ($(this).scrollTop() >= $('#check_scroll_change_bg').offset().top) {
          $('.template-index .featured-blog-index').removeClass('color-scheme-1').addClass('color-scheme-fdc39ac6-e0de-4bf6-bdf2-30d566de1eeb');
          $('.template-index .logos_list_grid_index').removeClass('color-scheme-1').addClass('color-scheme-fdc39ac6-e0de-4bf6-bdf2-30d566de1eeb');
       }
      //END check scroll screen turns black when hovering over blog posts

      

      //check scroll to CASE STUDIES SECTION
     if (windowWidth > 991) {
       var hT = $('#down').offset().top,
       hH = $('#down').outerHeight(),
       wH = $(window).height(),
       wS = $(this).scrollTop();
       var sum = wS - (hT+hH-wH) ;

      var widthList = 0;
      $('.project_list_index .project_item').each(function() {
          widthList += $(this).outerWidth( true );
      });
      if (wS > (hT+hH-wH)){
         console.log('you have scrolled to  #down! ==='+sum+'--wS--'+wS);
          if(sum < 175){
            $('.project_list_index').css({
              'transform-style': 'preserve-3d',
              'will-change': 'transform',
              "transform": `translate3d(-${sum}%, 0, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
            });
          }else{
            $('.project_list_index').css({
              'transform-style': 'preserve-3d',
              'will-change': 'transform',
              "transform": `translate3d(-175%, 0, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
            });
          }
       }
     }
      

        
    } else {
      //check scroll screen turns black when hovering over blog posts
       if ($(this).scrollTop() < $('#check_scroll_change_bg').offset().top) {
          $('.template-index .featured-blog-index').removeClass('color-scheme-fdc39ac6-e0de-4bf6-bdf2-30d566de1eeb').addClass('color-scheme-1');
         $('.template-index .logos_list_grid_index').removeClass('color-scheme-fdc39ac6-e0de-4bf6-bdf2-30d566de1eeb').addClass('color-scheme-1');
       }
      //END check scroll screen turns black when hovering over blog posts


     if (windowWidth > 991) {
      if ($(this).scrollTop() < $('.section-logos-list').offset().top) {
         var hT = $('#down').offset().top,
         hH = $('#down').outerHeight(),
         wH = $(window).height(),
         wS = $(this).scrollTop();
         var sum = wS - (hT+hH-wH-10) ;

         if (wS > (hT+hH-wH)){
           if(sum < 175){
              $('.project_list_index').css({
                'transform-style': 'preserve-3d',
                'will-change': 'transform',
                "transform": `translate3d(-${sum}%, 0, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
              });
           }
         } 
        if ($(this).scrollTop() < $('#down').offset().top) {
          $('.project_list_index').css({
              'transform-style': 'preserve-3d',
              'will-change': 'transform',
              "transform": `translate3d(0%, 0, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
            });
        }
      }
     }
      
      
         
    }
    position = scroll;
});

/*
$(document).ready(function() {

  var width = 0;
  $('.project_list_index .project_item').each(function() {
      width += $(this).outerWidth( true );
  });
  
  let scrollPosition = 0;
  const maxScrollX = (width - $('.sticky').width())*2;
 
  $('.sticky').on('mousewheel DOMMouseScroll', function(e) {
      e.preventDefault();
      const delta = e.originalEvent.wheelDelta || -e.originalEvent.detail;
        
      scrollPosition += (delta < 0 ? 100 : -100);

      if (scrollPosition < 0) {
            scrollPosition = 0;
      }
      if (scrollPosition > maxScrollX) {
            scrollPosition = maxScrollX;
      }

      console.log('scrollPosition == '+scrollPosition);
      console.log('maxScrollX == '+maxScrollX);

      $('.project_list_index').css('transform', `translate3d(-${scrollPosition}px, 0, 0)`);
    
    });
});

*/

 $(document).ready(function(){
  $('a.social-icon[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});

